import { SearchIdNamesEnum } from '../enums/SearchIdNamesEnum';

export const searchFilterMapper = (title: string) => SearchIdNamesEnum[title];
